class MultiStepForm {
  constructor(formElement, validationRules) {
    this.currentStep = 0;
    this.formData = {};
    this.formElement = formElement;
    this.stepElements = [];
    this.validationRules = validationRules;
    this.errorElement = this.formElement.querySelector('.form__error');
    this.previousElement = this.formElement.querySelector('.form__previous');
    this.nextElement = this.formElement.querySelector('.form__next');
    this.submitElement = this.formElement.querySelector('.form__submit');
    this.progressBarElement = this.formElement.querySelector('.form__progress-bar');
    this.progressBarTextElement = this.formElement.querySelector('.form__progress-bar__text');
    this.radioGroupAutoElements = Array.from(this.formElement.querySelectorAll('.radio-group.auto input[type="radio"]')); // Select radio inputs only.
    this.init();
  }

  init() {
    this.render();

    this.formElement.addEventListener('submit', (e) => {
      e.preventDefault();
      this.nextStep();
    });
    this.previousElement.addEventListener('click', (e) => {
      e.preventDefault();
      this.previousStep();
    });
    this.submitElement.addEventListener('click', (e) => {
      e.preventDefault();
      this.submitForm();
    });

    this.radioGroupAutoElements.forEach((radioInputElement) => {
      radioInputElement.addEventListener('change', (e) => {
        // go to next step with slight delay
        setTimeout(() => {
          this.nextStep();
        }, 300);
      });
    });
  }

  render() {
    this.stepElements = Array.from(this.formElement.querySelectorAll('.step'));

    this.stepElements.forEach((stepElement, index) => {
      if (index !== this.currentStep) {
        stepElement.classList.add('hidden');
      }
    });
    this.progressBar();
  }

  validate(stepIndex) {

    const inputs = this.stepElements[stepIndex].querySelectorAll('input, select, textarea');
    let isValid = true;
    let errorMessages = [];

    inputs.forEach((input) => {
      const rule = this.validationRules[input.name];

      if (!rule) return;

      if (rule.test(input.value)) {
        this.hideError();
        console.log('valid')
        // remove an error class from the input
        input.parentElement.classList.remove('error');
      } else {
        console.log(rule.message)
        errorMessages.push(rule.message);

        // add an error class to the input
        input.parentElement.classList.add('error');
        isValid = false;
        console.log('invalid')
      }
    });

    if (!isValid) {
      this.showError(errorMessages);
    }

    return isValid;
  }

  showError(messages) {
    // clear the error element
    this.errorElement.innerHTML = '';

    // remove duplicate messages
    messages = messages.filter((message, index) => messages.indexOf(message) === index);
    // create a ul element
    const ul = document.createElement('ul');
    // loop the messages, append them as li elements to the ul
    messages.forEach((message) => {
      const li = document.createElement('li');
      li.innerText = message;
      ul.appendChild(li);
    });
    // append the ul to the error element
    this.errorElement.appendChild(ul);
    // remove the hidden class from the error element
    this.errorElement.classList.remove('hidden');
  }

  hideError() {
    this.errorElement.textContent = '';
    this.errorElement.classList.add('hidden');
  }

  showPreviousButton() {
    if (this.currentStep === 0) {
      this.previousElement.classList.add('hidden');
    } else {
      this.previousElement.classList.remove('hidden');
    }
  }

  progressBar() {
    const totalSteps = this.stepElements.length;
    const currentStep = this.currentStep + 1;
    const percent = (currentStep / totalSteps) * 100;
    this.progressBarElement.style.width = `${percent}%`;
    this.progressBarTextElement.innerText = `${currentStep} of ${totalSteps}`;
    this.progressBarElement.setAttribute('data-label', `${currentStep} of ${totalSteps}`);

  }

  checkIfLastStep() {
    if (this.currentStep === this.stepElements.length - 1) {
      this.formElement.querySelector('.form__submit').classList.remove('hidden');
      this.formElement.querySelector('.form__next').classList.add('hidden');
    } else {
      this.formElement.querySelector('.form__submit').classList.add('hidden');
      this.formElement.querySelector('.form__next').classList.remove('hidden');
    }
  }

  goToStep(stepIndex) {
    if (stepIndex >= 0 && stepIndex < this.stepElements.length) {
      console.log('go to step', stepIndex);
      // hide the old step
      this.stepElements[this.currentStep].classList.add('hidden');
      // show the new step
      this.currentStep = stepIndex;
      this.stepElements[this.currentStep].classList.remove('hidden');
      this.showPreviousButton();
      this.checkIfLastStep();
      this.progressBar();
    }
  }

  nextStep() {
    if (this.validate(this.currentStep)) {
      this.goToStep(this.currentStep + 1);
    }
  }

  previousStep() {
    this.goToStep(this.currentStep - 1);
    this.hideError();
  }
  submitForm() {
    if (this.validate(this.currentStep)) {
      this.collectFormData();
      this.postFormData();
    }
  }

  collectFormData() {
    const inputs = Array.from(this.formElement.querySelectorAll('input, select, textarea'));
    this.formData = inputs.reduce((data, input) => ({
      ...data,
      [input.name]: input.value
    }), {});

    console.log(inputs);
    console.log(this.formData);
  }

  postFormData() {
    const url = 'https://hooks.zapier.com/hooks/catch/2691603/3usn7ug/';
    fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify(this.formData),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((jsonResponse) => {
        console.log(jsonResponse);
        window.location.href = 'thankyou';
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

}

const validationRules = {

    'focus': {
      // check if a radio button is checked in the group
      test: (value) => document.querySelector(`input[name="focus"]:checked`) !== null,
      message: 'This field is required.'
    },
    'website': {
      test: (value) => value !== '',
      message: 'This field is required.'
    },
    'first_name': {
      test: (value) => value !== '',
      message: 'Please enter your name'
    },
    'surname': {
      test: (value) => value !== '',
      message: 'Please enter your name'
    },
    'email': {
      test: (value) => /^\S+@\S+\.\S+$/.test(value),
      message: 'Please enter a valid email address.'
    },
    'tel': {
      // test for uk phone number or mobile number
      test: (value) => /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/
  .test(value),
      message: 'Please enter a valid UK phone number (e.g., 07977365475).'
    }
};

const formElement = document.getElementById('multi-step-form');
// if the form exists on the page
if (formElement) {
    // create a new instance of the MultiStepForm class
  const multiStepForm = new MultiStepForm(formElement, validationRules);

}



function handleRadioClicks() {
  // Get all divs with class 'radio' within 'radio-group'
  const radioDivs = document.querySelectorAll('.radio-group .radio');

  // Add event listeners to each div
  radioDivs.forEach(div => {
    div.addEventListener('click', function(event) {

      event.preventDefault();

      // Get the radio input element inside the div
      const radio = this.querySelector('input[type="radio"]');

      // If the event target is the label and the 'for' attribute matches the radio id, or
      // if the event target is the radio itself, then check the radio and dispatch the change event
      if (
        (
          event.target.tagName.toLowerCase() === 'label'
          && event.target.htmlFor === radio.id
        )
        || event.target === radio
        || event.target === div
      ) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: false }));
      }
    });
  });
}


if (document.querySelector('.radio-group')) {
  handleRadioClicks();
}

// Navbar burger
function navbarBurger() {
    const navbarBurger = document.querySelector('.navbar__burger');
    const navbarMenu = document.querySelector('.navbar__links');
    navbarBurger.addEventListener('click', () => {
        navbarBurger.classList.toggle('active');
        navbarMenu.classList.toggle('active');
    });
}
if (document.querySelector('.navbar__burger')) {
    navbarBurger();
}

function faqs() {
    const faqs = document.querySelectorAll('.faq');
    faqs.forEach(faq => {
        const faqQuestions = faq.querySelectorAll('.faq__question');
        faqQuestions.forEach(faqQuestion => {
          faqQuestion.addEventListener('click', () => {
            faqQuestion.querySelector('.faq__answer').classList.toggle('active');
          })
        });
    });
}
if (document.querySelector('.faq')) {
    faqs();
}
